import { getParameterByName } from '../utils/commonFunctions';

const initialBuyCourseState = {
	productList: {},
	currentProductId: !!getParameterByName('productID')
		? getParameterByName('productID')
		: 0,
	productData: {},
	couponCode: !!getParameterByName('coupon') ? getParameterByName('coupon') : '',
	triggerBuyNow: false,
	discountedPrice: 0,
	apiCount: 0,
	paymentData: {},
	checkSum: '',
	paymentStatus: '',
	orderId: !!getParameterByName('orderid') ? getParameterByName('orderid') : 0,
	payment_type: '',
	transactionId: '',
	showPreviewCourses: false,
	relatedProductsList: [],
};

const changeCourse = {
	courseDetails: {},
};

const initialCourseState = {
	domains: [],
	domain: '',
	elementName: '',
	elementType: '',
	SumTimeLimit: 0,
	HideStart: 0,
	reviewModal: false,
	reviewAnswers: {},
	reviewAttemptDetails: {},
	FetchSuccess: false,
	FromPath: '',
	continueElementDetails: {},
	completedPercent: 0,
	currentUnitId: 0,
	totalAttempts: 0,
	coursedetails: {},
	completedAttempts: {},
	elementNamesAndType: {},
	isCoachCourse: false,
	requestedUnit: !!getParameterByName('unit_id')
		? parseInt(getParameterByName('unit_id'), 10)
		: !!sessionStorage.getItem('activeSessionUnit')
			? parseInt(sessionStorage.getItem('activeSessionUnit'), 10)
			: -1,
	attemptId: '',
	courseId: getParameterByName('course_id'),
	elementId: getParameterByName('element_id'),
	units: {},
	isSpeechOn: false,
	coachDetails: {},
	calendlyUrl: '',
	displayText: '',
	taskScheduleId: 0,
	taskList: [],
	callHistory: [],
	selectedFile: null,
	fileSubmitStatus: false,
	fileError: '',
	onScheduleCallClick: '',
	warningOnScheduleCall: '',
	cancelReason: '',
	continueAttemptId: 0,
	continueElementId: 0,
	continueElementName: '',
	continueElementType: '',
	startAttemptSuccess: false,
	studentGrade: '',
	certificateUrl: '',
	upnextAll: [],
	courseSuccess: false,
	category: '',
	courseType: '',
	showTestInstr: false,
	showGrade: false,
	showCancelReason: false,
	showInfo: false,
	activeUnit: 1,
	previewMode: false,
	show_dailystep: true,
};

const initialMyStepState = {
	score: {},
	reportUrl: '',
	report: {},
	upNext: {},
	jwplayerStatus: {},
	jw_seek_disabled_status: false,
	show_coachcalls: false,
	show_liveclass: false,
	show_settings_history: false,
	online_lessons: false,
	settings: false,
};

const notificationState = {
	notificationList: {},
};

const initialParentDashboardState = {
	parentName: '',
	childrenList: [],
	editChildDetails: {},
	childToken: '',
	showAddChild: false,
	showEditChild: false,
	courses: {},
	productDetail: {},
	activeChildId: '',
	call_time: '',
	completed_calls: 0,
	meeting_id: 0,
	total_calls: 0,
	calendly_url: '',
	call_status: '',
	reportUrl: '',
	cert_url_speech: '',
	score_speech: 0,
	is_parentpurchased: false,
};

const resetData = {
	graduate_year: '',
	userJob: '',
	jobType: '',
	preparingExam: '',
	skills: '',
	primaryPurpose: '',
	userTypeOther: '',
	preparingExamOther: '',
	skillsOther: '',
	userJobOther: '',
	jobTypeOther: '',
	primaryPurposeOther: '',
	otp: '',
};

const initialProfileState = {
	phone: '',
	fullName: '',
	email: '',
	success: false,
	IsLogin: true, //to verify user logged in or not
	errorMsg: '', // to show the error message popup
	msg: '',
	name: '',
	userType: '',
	gender: '',
	birthDate: '',
	userEducation: '',
	isEnglishMedium: false,
	aspectToDevelop: [],
	graduateYear: '',
	userJob: '',
	jobType: '',
	preparingExam: '',
	skills: '',
	primaryPurpose: '',
	userTypeOther: '',
	preparingExamOther: '',
	skillsOther: '',
	userJobOther: '',
	primaryPurposeOther: '',
	additionalSection: 'None',
	title: '',
	fieldGraduateYear: 'none',
	fieldUserJob: 'none',
	fieldJobType: 'none',
	fieldPreparingExam: 'none',
	fieldSkills: 'none',
	fieldPrimaryPurpose: 'none',
	editProfile: false,
	isMobVerified: false,
	isOtpSent: false,
	isSubscribe: '',
	showSubscribe: false,
	getUserInfo: false,
	showVerifyMob: false,
	childStatus: false,
	resetState: false,
};

const initialTestPageState = {
	startAttemptSuccess: false,
	currentAttemptId: 0,
	answer_count: 0,
	question_count: 0,
	aSectionId: 0,
	elementType: '',
	attemptProgress: 0,
	timeRemaining: 0,
	isFeedback: false,
	questions: {},
	feedback: {},
	response: {},
	leftSectionProps: {},
	rightSectionProps: {},
	feedbackProps: {},
	youtubeProps: {},
	submitFeedback: false,
	disableSubmit: true,
	isPauseTimer: false,
	resetCounter: 0,
	resetCounters: [],
	submitButton: 'SUBMIT',
	audioblob: [],
	videoblob: [],
	leftFeedbackProps: {},
	thanksval: {},
	feedbackChoicesOrder: {},
	feedbackImageChoicesOrder: {},
	prevVideoId: '',
	isMicPermitted: false,
	isClose: 0,
	showReview: false,
	showThankModal: false,
};

export {
	initialBuyCourseState,
	changeCourse,
	initialCourseState,
	notificationState,
	initialParentDashboardState,
	resetData,
	initialProfileState,
	initialTestPageState,
	initialMyStepState,
};
